@if (isVisible) {
  <button
    color="primary"
    mat-icon-button
    (click)="handleClick()"
    class="app-scroll-button"
    title="{{ 'Scroll to bottom to continue' | translate }}"
    type="button"
    >
    <img
      src="/assets/images/btn-scroll-down.png"
      alt="{{ 'Scroll to bottom to continue' | translate }}"
      />
  </button>
}
